import { createContext, useContext, useMemo, useCallback, useState } from "react";

const PxoTableContext = createContext();

const createTableDivisions = () => ({

    Granel: {
      table:  { fullRows: [], bank: {}, yard: {}, branch: {}, terminal: {} },
      median: { fullRows: [], bank: {}, yard: {}, branch: {}, terminal: {} }
    },

    "Outros Segmentos": {
      table:  { fullRows: [], bank: {}, yard: {}, branch: {}, terminal: {} },
      median: { fullRows: [], bank: {}, yard: {}, branch: {}, terminal: {} }
    }
})

export function PxoTableProvider({ children }) {
    
    const [ hiddensTerminals, setHiddensTerminals   ] = useState([]);
    const [ hiddensBanks,     setHiddensBanks       ] = useState([]);
    const [ hiddenBranches,   setHiddenBranches     ] = useState([]);

    const [ editingCellId,    setEditingCellId      ] = useState(null);

    const [ updatePxoTable,     setUpdatePxoTable     ] = useState(false)
    const [ pxoTables,          setPxoTables          ] = useState([])

    const [ tableDescarga,          setTableDescarga            ] = useState(createTableDivisions)
    const [ tableProdutividade,     setTableProdutividade       ] = useState(createTableDivisions)
    const [ tableOciosidade,        setTableOciosidade          ] = useState(createTableDivisions)

    const [ totalsProdutividade,    setTotalsProdutividade      ] = useState(createTableDivisions)
    const [ totalsDescarga,         setTotalsDescarga           ] = useState(createTableDivisions)




    const toggleIn = useCallback((prev, item) => (
        prev.includes(item) ? prev.filter(x => x !== item) : [...prev, item]
    ), [])

    const toogleDisplayTerminal = useCallback((terminalName) => {
        setHiddensTerminals(prev => toggleIn(prev, terminalName))
    }, [toggleIn])
    
    const toogleDisplayBanks = useCallback((bankName) => {
        setHiddensBanks(prev => toggleIn(prev, bankName))
    }, [toggleIn])
    
    const toogleDisplayBranches = useCallback((branchKey) => {
        setHiddenBranches(prev => toggleIn(prev, branchKey))
    }, [toggleIn])

    const value = useMemo(() => ({
        
        pxoTables,        
        setPxoTables,  
        
        setTotalsProdutividade, 
        setTotalsDescarga,

        totalsProdutividade,
        totalsDescarga,
        
        tableDescarga, 
        setTableDescarga, 

        tableProdutividade,      
        setTableProdutividade,
        
        tableOciosidade,    
        setTableOciosidade, 
        
        hiddensTerminals,
        hiddensBanks,

        hiddenBranches,
        toogleDisplayTerminal,

        toogleDisplayBanks,
        toogleDisplayBranches,

        editingCellId,
        setEditingCellId,

        updatePxoTable,
        handleUpdatePxoTable: () => setUpdatePxoTable(!updatePxoTable),
        

    }), [

        pxoTables,
        tableOciosidade,
        
        hiddensTerminals, 
        hiddensBanks, 
        hiddenBranches, 
        toogleDisplayTerminal, 
        toogleDisplayBanks, 
        toogleDisplayBranches, 
        editingCellId, 
        updatePxoTable,
        
        tableDescarga,         // 🔴 ALTERADO: adicionado
        tableProdutividade,    // 🔴 ALTERADO: adicionado

        totalsDescarga, 
        totalsProdutividade
    ])

    return (
        
        <PxoTableContext.Provider value={value}>
            {children}
        </PxoTableContext.Provider>
    ) 
}


export function usePxoTableContext() {
    return useContext(PxoTableContext);
}